import { format, parseISO } from 'date-fns';

import type { LogEntry } from '@/types/log-entry';
import type { Property } from '@/types/property';
import { CollapsibleWidget } from './collapsible-widget';
import { ConditionsWidget } from './ConditionsWidget';
import { RecentLogSection } from './RecentLogSection';

// ---------------------------------------------------------------------------
// CollapsibleConditions
//
// ConditionsWidget now has its own smart collapsible header — wrap it without
// an additional CollapsibleWidget shell so it doesn't double-nest.
// ---------------------------------------------------------------------------

interface CollapsibleConditionsProps {
  properties: Property[];
  /** ID of the user's primary property (renamed from defaultPropertyId in M-07). */
  primaryPropertyId: string | null;
}

export function CollapsibleConditions({ properties, primaryPropertyId }: CollapsibleConditionsProps) {
  return (
    <ConditionsWidget properties={properties} primaryPropertyId={primaryPropertyId} />
  );
}

// ---------------------------------------------------------------------------
// CollapsibleRecentScouts
// ---------------------------------------------------------------------------

interface CollapsibleRecentScoutsProps {
  entries: LogEntry[];
  onEntryClick: (id: string) => void;
  onAddClick: () => void;
}

export function CollapsibleRecentScouts({
  entries,
  onEntryClick,
  onAddClick,
}: CollapsibleRecentScoutsProps) {
  const latest = entries[0];
  const summaryText = latest
    ? `${entries.length} entr${entries.length !== 1 ? 'ies' : 'y'} · Last: ${format(parseISO(latest.date), 'MMM d')}`
    : 'No recent entries';

  return (
    <CollapsibleWidget
      id="recent-scouts"
      title="RECENT SCOUTS"
      summary={summaryText}
    >
      {/* variant="seated": no top border/radius — CollapsibleWidget header provides the top edge */}
      <RecentLogSection entries={entries} onEntryClick={onEntryClick} onAddClick={onAddClick} variant="seated" />
    </CollapsibleWidget>
  );
}
